export default __webpack_public_path__ + "static/media/_DSC0232.11fb17a7.JPG";